import { useField } from 'formik';

import * as S from './styles';

interface ISwitchInputProps {
  name: string;
  onValueChange?: (value: boolean) => void;
  disabled?: boolean;
  className?: string;
}

const SwitchInput: React.FC<ISwitchInputProps> = ({
  name,
  onValueChange,
  disabled,
  className,
  children,
}) => {
  const [field, , helpers] = useField<boolean>({ name });

  const toggle = () => {
    const value = !field.value;
    helpers.setValue(value);
    if (onValueChange) onValueChange(value);
  };

  return (
    <S.Container className={className}>
      <button
        type="button"
        role="switch"
        id={name}
        aria-checked={field.value}
        data-state={field.value ? 'checked' : 'unchecked'}
        disabled={disabled}
        onClick={toggle}
      >
        <span />
      </button>

      <label htmlFor={name}>{children}</label>
    </S.Container>
  );
};

export default SwitchInput;
